export default __webpack_public_path__ + "static/media/hyundai.cbbdf546.svg";